import { useEffect } from "react";
import { absUrl, SITE_URL } from "@/lib/api";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function Seo({ title, description, path = "/", image, noindex = false, jsonLd }) {
  useEffect(() => {
    const t = title || "Rüzgar Özel Güvenlik";
    document.title = t;
    const url = `${SITE_URL}${path}`;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", absUrl(image));
    let link = document.head.querySelector('link[rel="canonical"]');
    if (noindex) {
      if (link) link.remove();
      return;
    }
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
  }, [title, description, path, image, noindex]);

  if (!jsonLd) return null;
  const items = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
  return items.map((j) => (
    <script key={j["@type"] || "ld"} type="application/ld+json">{JSON.stringify(j)}</script>
  ));
}

export const faqLd = (faqs) =>
  faqs?.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }
    : null;

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: `${SITE_URL}${it.path}` })),
});

export const businessLd = (s) => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#business`,
  name: s.company_name,
  legalName: s.legal_name,
  url: `${SITE_URL}/`,
  logo: absUrl("/assets/logo-shield.png"),
  image: absUrl(s.hero_image),
  telephone: s.phone,
  ...(s.email ? { email: s.email } : {}),
  ...(s.maps_url ? { hasMap: s.maps_url } : {}),
  foundingDate: "2021-09-21",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Değirmendere Mahallesi, Süleyman Demirel Bulvarı, Sanayi Caddesi No: 1/103",
    addressLocality: "Kuşadası",
    addressRegion: "Aydın",
    addressCountry: "TR",
  },
  areaServed: (s.service_regions || []).map((r) => ({ "@type": "Place", name: r })),
  sameAs: Object.values(s.socials || {}).filter(Boolean),
});
